<ng-template #OBJ_modal_iframe>
	<div class="modal-header">
	<h4 class="modal-title pull-left">Editor</h4>
	<button type="button" style="margin-right:10px" class="btn btn-warning btn-circle pull-right" aria-label="Close"
		(click)="closeEditorWithoutSaving()" title="{{'oEditor.sCloseWithoutSaving'|translate}}">
		<i class="fa fa-remove"></i>
	</button>

	</div>
	<div class="modal-body">
		<div class="tig-iframe">
			<br />
			<div class="clear"></div>
			<iframe id="my-iframe" width="100%" height="90%" frameborder="0" allowfullscreen
				[srcdoc]="OBJ_iframe_content"></iframe>
		</div>
	</div>
</ng-template>

<div class="form-group" [formGroup]="OBJ_form_group" [ngClass]="{'has-error': isInvalid()}">
	<label class="col-lg-2 control-label" [ngClass]="{'tgi-required': isRequired()}">{{getLabelName()|translate}}
		<span *ngIf="isRequired()" class="tgi-asterisk"> *</span></label>
	<div class="col-lg-8">
		<textarea class="form-control" [(ngModel)]="OBJ_field_config.value" [placeholder]="getLabelName()|translate"
			[readonly]="OBJ_field_config?.readonly" [formControlName]="OBJ_field_config.name">
            </textarea>
		<tig-form-error [OBJ_form_control]="OBJ_form_group.get(OBJ_field_config.name)"></tig-form-error>
	</div>
	<button type="button" #btn id="{{STR_btn_id}}" class="btn btn-info btn-circle" (click)="openEditor(btn)"
		title="editor"><i class="fa fa-pencil-square-o"></i></button>
</div>
